<template>
  <div class="container">
    <div style="position: relative; width: 100%">
      <div style="display: flex; flex-direction: row; align-items: center; width: 100%; justify-content: space-between">
        <h4 class="title" style="flex: 8;">{{isEdit ? $t('device.editComponent') : $t('device.addNewComponent')}}</h4>
        <div style="flex: 2;">
          <el-button v-if="isEdit && subDeviceDetailInfo" size="mini" class="orange-button" @click="printSubDeviceLabel">
            {{$t('common.printLabel')}}
          </el-button>
          <el-button v-if="isEdit" :loading="loading" type="danger" size="mini" @click="deleteSubDevice">
            {{$t('common.delete')}}
          </el-button>
        </div>
      </div>
      <div class="separator"></div>
      <div class="info-container">
        <el-form size="small" :model="form" style="width: 87%;" ref="refForm" :rules="rules" label-width="180px">
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('common.address') + ':'" prop="address">
                <el-input
                  v-model.trim="form.address"
                  name="address"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="255"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('common.componentName') + ':'" prop="deviceName">
                <el-input
                  v-model.trim="form.deviceName"
                  name="deviceName"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('common.componentModel') + ':'" prop="deviceModel">
                <el-input
                  v-model.trim="form.deviceModel"
                  name="deviceModel"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('common.componentNumber') + ':'" prop="deviceNumber">
                <el-input
                  v-model.trim="form.deviceNumber"
                  name="deviceNumber"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('common.productionDate') + ':'" prop="productionDate">
                <el-date-picker
                  v-model="form.productionDate"
                  type="date"
                  size="small"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('common.softwareVersion') + ':'" prop="softwareVersion">
                <el-input
                  v-model.trim="form.softwareVersion"
                  name="softwareVersion"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="255"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('common.componentSerialNo') + ':'" prop="componentSerialNo">
                <el-input
                  v-model.trim="form.deviceSerialNo"
                  name="componentSerialNo"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="255"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('common.status') + ':'" prop="status">
                <el-select
                  v-model="form.status"
                  clearable
                  filterable
                  size="small"
                  style="width: 100%">
                  <el-option
                    v-for="item in defaultSubDeviceStatus"
                    :key="item.value"
                    :label="item.explain"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="24">
              <el-form-item :label="$t('common.comment') + ':'">
                <el-input
                  v-model="form.comment"
                  name="comment"
                  type="textarea"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="255"
                  :rows="3"
                  show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0" class="bottom-container">
            <el-button :loading="loading" size="small" type="primary" @click="submitForm">{{isEdit ? $t('common.update') : $t('common.save')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  deviceAdd,
  deviceUpdate,
  deviceDelete,
  devicesList,
} from '@/api/device';
import {
  defaultSubDeviceStatus,
} from '@/utils/defines';
import {initDeviceLabel} from "@/utils/deviceLabel";
import {remove_ie_header_and_footer} from "@/utils";

const defaultForm = {
  address: undefined,
  deviceName: undefined,
  deviceModel: undefined,
  deviceNumber: undefined,
  productionDate: undefined,
  softwareVersion: undefined,
  deviceSerialNo: undefined,
  status: 1,
  comment: undefined,
}

export default {
  name: "deviceDetail",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {...defaultForm, deviceNumber: this.createSubDeviceNumber()},
      rules: {
          address: [{required: true, trigger: 'change', message: this.$t('validate.addressCanNotBeEmpty') }],
          deviceName: [{required: true, trigger: 'change', message: this.$t('validate.componentNameCanNotBeEmpty') }],
          deviceModel: [{required: true, trigger: 'change', message: this.$t('validate.componentModelCanNotBeEmpty') }],
          deviceNumber: [{required: true, trigger: 'change', message: this.$t('validate.componentNumberCanNotBeEmpty') }],
          productionDate: [{required: true, trigger: 'change', message: this.$t('validate.productionDateCanNotBeEmpty') }],
          status: [{required: true, trigger: 'change', message: this.$t('validate.statusCanNotBeEmpty') }],
      },
      loading: false,
      defaultSubDeviceStatus,
      fileList: [],
      tempRoute: {},
      subDeviceId: undefined,
      subDeviceDetailInfo: undefined,
    };
  },
  computed: {
  },
  mounted() {
    if (this.isEdit) {
      this.subDeviceId = this.$route.params && this.$route.params.subDeviceId;
      this.deviceDetail();
    }
    this.tempRoute = Object.assign({}, this.$route);
  },
  methods: {
    async deviceDetail() {
      try {
        const res = await devicesList({
          id: this.subDeviceId,
          flag: [100, 100],
        });
        const { data } = res;
        const devices = data.records || [];
        if (devices.length === 0) {
          this.$message({
            type: 'error',
            message: this.$t('device.componentInfoMissing'),
          });
          return;
        }
        this.subDeviceDetailInfo = devices[0];
        const {
          addr,
          deviceName,
          deviceModel,
          deviceNo,
          productionDate,
          softwareVersion,
          deviceSerialNo,
          status,
          comment,
        } = devices[0];
        this.form = {
          address: addr,
          deviceName: deviceName,
          deviceModel: deviceModel,
          deviceNumber: deviceNo,
          productionDate: productionDate,
          softwareVersion: softwareVersion,
          deviceSerialNo: deviceSerialNo,
          status: status,
          comment: comment,
        };
      } catch (e) {
        // do nothing.
      }
    },
    deleteSubDevice() {
      this.$confirm(this.$t('device.thisActionWillDeleteThisComponent'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          subDeviceId,
        } = this;
        this.loading = true;
        try {
          await deviceDelete({
            ids: [subDeviceId],
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
          this.backSubDeviceListPage();
        } catch (e) {
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        // do nothing.
      });
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          if (this.isEdit) {
            this.deviceUpdate();
          } else {
            this.deviceAdd();
          }
        }
      });
    },
    async deviceUpdate() {
      const {
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        productionDate,
        softwareVersion,
        deviceSerialNo,
        status,
        comment,
      } = this.form;
      this.loading = true;
      try {
        await deviceUpdate({
          id: this.subDeviceId,
          addr: address || undefined,
          deviceName: deviceName || undefined,
          deviceModel: deviceModel || undefined,
          deviceNo: deviceNumber || undefined,
          productionDate: productionDate || undefined,
          status: status || undefined,
          softwareVersion: softwareVersion || undefined,
          comment: comment || undefined,
          deviceSerialNo: deviceSerialNo || undefined,
        });
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
        this.backSubDeviceListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async deviceAdd() {
      const {
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        productionDate,
        softwareVersion,
        status,
        comment,
        deviceSerialNo,
      } = this.form;
      this.loading = true;
      try {
        await deviceAdd({
          flag: 100,
          addr: address || undefined,
          deviceName: deviceName || undefined,
          deviceModel: deviceModel || undefined,
          deviceNo: deviceNumber || undefined,
          productionDate: productionDate || undefined,
          status: status || undefined,
          softwareVersion: softwareVersion || undefined,
          comment: comment || undefined,
          deviceSerialNo: deviceSerialNo || undefined,
        });
        this.$message({
          type: 'success',
          message: this.$t('common.createSuccess'),
        });
        this.backSubDeviceListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    backSubDeviceListPage() {
      this.$router.replace({ path: '/asset-management/subDevice' });
      this.$store.dispatch('tagsView/delView', this.tempRoute);
    },
    createSubDeviceNumber() {
      let str = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789';
      let n = 4;
      let s = '';
      let rand = '';
      let length = str.length;
      for (let i = 0; i < n; i++) {
        rand = Math.floor(Math.random() * length);
        s += str.charAt(rand);
      }
      return 'WC' + moment().format('YYMM') + s;
    },
    printSubDeviceLabel() {
      let iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      const {
        subDeviceDetailInfo,
      } = this;
      iframe = initDeviceLabel({
        iframe,
        ...subDeviceDetailInfo,
        company: '网策科技有限公司',
        isSubDevice: true,
      });
      setTimeout(() => {
        if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
          remove_ie_header_and_footer();
        }
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
        iframe = null;
      }, 200);
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
}
.separator {
  width: 100%;
  height: 1px;
  background: #E5E5E5;
  display: block;
}
.title {
  margin: 10px 20px;
  font-size: 16px;
  color: #555555;
}
.info-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
}
.bottom-container {
  text-align: center;
  margin: 20px 0;
}
.orange-button {
  background: #FF8605;
  color: white;
  border: 0;
}
</style>
